import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDateRangePicker } from "@angular/material/datepicker";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { UiService } from "app/helper-components/UiService";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { UserDataService } from "app/helpers/user-data.service";
import { environment } from "environments/environment";
import moment, { Moment } from "moment";

@Component({
  selector: "app-development",
  templateUrl: "./development.component.html",
  styleUrls: ["./development.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DevelopmentComponent implements OnInit, AfterViewInit {
  parameters: any;
  selectedYear: any = moment().format("YYYY");
  @Input() selectedDate: any;
  selectedType = 1;
  data: any = {};

  constructor(
    private userDataService: UserDataService,
    private _activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private postService: PostService,
    private uiService: UiService,
    private translate: TranslateService,
  ) {
    this.selectedDate = userDataService.serverTime.format("YYYY");
  }

  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe((data) => {
      this.parameters = this.helper.getParameters(data["_v"]);
    });
  }

  ngAfterViewInit(): void {
    this.fetchData();
  }

  fetchData() {
    if (
      this.data.hasOwnProperty(this.selectedType) &&
      this.data[this.selectedType].data.length > 0
    ) {
      return;
    }

    this.uiService.showLoading();
    var request = {
      getMonthlyWiseSummary: 1,
      party_post_group_id: 5,
      type: this.selectedType,
      year: this.selectedYear,
    };
    request[this.parameters.place_key] = this.parameters.place_id;

    this.postService
      .post(
        environment.API_NOTES,
        this.helper.getURLSearchParamsFromObject(request),
      )
      .subscribe((val) => {
        this.uiService.hideLoading();
        if (val.status == "success") {
          this.data[this.selectedType] = {};
          this.data[this.selectedType].data = val.data;
          this.data[this.selectedType].html = "";
          this.generateHTML();
        }
      });
  }

  date = new FormControl(moment());
  chosenYearHandler(
    normalizedYear: Moment,
    datepicker: MatDateRangePicker<Moment>,
  ) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);

    datepicker.close();

    this.selectedYear = ctrlValue.format("YYYY");
    this.data = {};
    this.fetchData();
  }

  onTabChanged(event) {
    this.selectedType = event.index + 1;
    this.fetchData();
  }

  generateHTML() {
    if (this.data.hasOwnProperty(this.selectedType)) {
      var tabData = this.data[this.selectedType];
      var html = ``;
      html += `<table class="pangalipu mt-12">`;
      html += `<tr>`;
      html += `<th class="head accent accent" style="width:200px;">#</th>`;

      for (let num of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]) {
        let month = moment(num, "M").format("MMMM");
        html +=
          `<th class="head accent accent">` +
          this.translate.instant(month) +
          `</th>`;
      }
      html +=
        `<th class="head accent accent">` +
        this.translate.instant("Total") +
        `</th>`;
      html += `</tr>`;

      tabData.data.forEach((element) => {
        html += `<tr>`;
        html +=
          `<td class="head accent accent">` + element.const_name + `</td>`;

        var totalRight = 0;
        for (let num of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]) {
          var monthData = null;
          element.months.forEach((element) => {
            if (element.month == num) {
              monthData = element;
            }
          });

          if (monthData != null) {
            totalRight += parseInt(monthData.amount);
            html += `<td>` + monthData.amount + `</td>`;
          } else {
            html += `<td>0</td>`;
          }
        }

        html += `<td>` + totalRight + `</td>`;

        html += `</tr>`;
      });

      html += `<tr>`;
      html +=
        `<td class="head accent accent">` +
        this.translate.instant("Total") +
        `</td>`;

      var totalRight = 0;
      for (let num of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]) {
        var totalBottom = 0;

        tabData.data.forEach((element) => {
          element.months.forEach((element) => {
            if (element.month == num) {
              totalBottom += parseInt(element.amount);
            }
          });
        });
        html += `<td>` + totalBottom + `</td>`;
        totalRight += totalBottom;
      }

      html += `<td>` + totalRight + `</td>`;

      html += `</tr>`;

      html += `</tbody>`;
      html += `</table>`;
      this.data[this.selectedType].html = html;
    }
  }
}
